import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/SideBar';
import Navbar from './login/DashNav';
import UnauthorizedMessage from './login/401';
import Loader from '../../components/Loader/Loader';

const Unauthorized: React.FC = () => {
  return <UnauthorizedMessage />;
};

const DashboardLayout: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [accessGranted, setAccessGranted] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const res = await fetch('/api/authAccess');
        if (res.status === 200) {
          setAccessGranted(true);
        } else {
          // Not allowed, redirect or show error
          window.location.href = '/404';
        }
      } catch (err) {
        console.error('Error checking access:', err);
        window.location.href = '/404';
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, []);

  if (loading) return <Loader />;
  if (!accessGranted) return <Unauthorized />; // Optional: fallback if redirection fails

  return (
    <div className="grid-container">
      <div className="flex-row gap-0">
        <Sidebar />
        <div className="w-100 grid-padding-lr">
          <Navbar />
          <div className="ptb-2">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
